var render = function render(_c,_vm){return _c('Route',{class:['MainLogo', _vm.data.class, _vm.data.staticClass],attrs:{"exact":true,"title":"Sun Investment Group","to":"Index"}},[_c('Pic',{attrs:{"alt":"Sun Investment Group","src":"../../assets/logo.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }